import { EventBus } from '@johnlewispartnership/wtr-website-eventbus';

export const MONETATE_EVENTS_CHANNEL = 'wtr-events.monetate';
export const COMMON_EVENTS_LOADED_EVENT = 'common_events_loaded';

const MonetateEventBus = new EventBus(MONETATE_EVENTS_CHANNEL);
export default MonetateEventBus;
